import React from "react";
import ModalInDrawer from "../ui/ModalInDrawer";
import { useSelector } from "react-redux";

const EditarComentarioVendedorServicioCotizacion = ({open, onClose, comentarioVendedor, setComentarioVendedor }) => {

  const userRedux = useSelector((state)=>state.auth.user);
    
  return (
    <ModalInDrawer
      activeModal={open}
      onClose={onClose}
      centered
      title="Editar comentario de vendedor"
    >
      <div className=" mb-4 ">
        <div className="flex">
          <div className="me-3 shrink-0">
            <div
              className="block  "
            >
              <img
                className=" w-9 h-9 object-cover rounded-full"
                src={userRedux.foto ? userRedux?.foto?.url : "/assets/images/avatars/avatar_25.jpg"}
                alt="Flowbite logo"
              />
            </div>
          </div>
          <div>
            <p className="mb-1 text-base font-semibold leading-none text-gray-900 ">
              <span href="#" className="">
                {userRedux?.name}
              </span>
            </p>
            <p className="mb-3 text-gray-600 text-xs capitalize font-normal">{userRedux?.puesto}</p>
         
          

           
          </div>
        </div>
      </div>
      <div className="w-full mb-4 border border-gray-200 rounded-lg bg-gray-50  ">
        <div className="px-4 py-2 bg-white rounded-t-lg ">
          <label htmlFor="comment" className="sr-only">
            Comentario de vendedor
          </label>
          <textarea
            id="comment"
            rows="8"
            value={comentarioVendedor}
            onChange={(e) => setComentarioVendedor(e.target.value)}
            className="w-full px-0 text-xs text-gray-900 bg-white border-0  focus:ring-0 "
            placeholder="Escribe un comentario"
            required
          ></textarea>
        </div>
        <div className="flex items-center justify-center px-3 py-2 border-t ">
          <button
            type="button"
            onClick={() => onClose()}
            className="inline-flex items-center  text-center py-2.5 px-4 text-xs font-medium  text-white bg-blue-700 rounded-lg focus:ring-4 focus:ring-blue-200  hover:bg-blue-800"
          >
            Guardar
          </button>
        </div>
      </div>
    </ModalInDrawer>
  );
};

export default EditarComentarioVendedorServicioCotizacion;
